export const CONTACT_EMAIL = "anear.info@gmail.com"

